import {
    GET_ALL_LOB,
    GET_LOB,
    GET_COST_CENTER_LOB,
    GET_ACCOUNTS,
    GET_COST_CENTER,
    CAL_LOADING,
    ADD_LOB
  } from "../actions/ExtracurricularCoursesAdminLOBAction";
  
  
  const initialState = {
    lobslist: [],
    lob: [],
    accounts:[],
    costcenterlist:[],
    costcenterloblist:[],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case CAL_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_ALL_LOB: {
            return{
                ...state,
                lobslist : [...action.data],
                location:[],
                loading: false,
                add : false,
            }
        }
        case GET_LOB: {
          return{
              ...state,
              lob : [...action.data],
              loading: false
          }
        }
        case GET_ACCOUNTS: {
            return{
                ...state,
                accounts : [...action.data],
                loading: false
            }
          }
          case GET_COST_CENTER: {
            return{
                ...state,
                costcenterlist : [...action.data],
                loading: false
            }
          }
          case GET_COST_CENTER_LOB: {
            return{
                ...state,
                costcenterloblist : [...action.data],
                loading: false
            }
          }
        case ADD_LOB: {
          return {
            ...state,
            location:[],
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  